<template>
  <div
    :class="[
      'VisionSlidoTab',
      'VisionSlidoTab--theme-' + props.theme,
      {
        'VisionSlidoTab--selected': props.selected,
        'VisionSlidoTab--disabled': props.disabled
      }
    ]"
  >
    <div class="VisionSlidoTab__bg" />
    <button
      class="VisionSlidoTab__btn"
      :disabled="props.disabled"
      @click="emits('selected')"
    >
      <slot />
    </button>
  </div>
</template>

<script setup lang="ts">
interface SlidoTabProps {
    selected?: boolean
    disabled?: boolean
    theme?: string
}

const props = withDefaults(defineProps<SlidoTabProps>(), {
    selected: false,
    disabled: false,
    theme: 'default'
})

const emits = defineEmits(['selected'])
</script>

<style lang="postcss" scoped>
.VisionSlidoTab {
    @apply relative w-full;
}

.VisionSlidoTab__bg {
    @apply hidden border rounded-lg absolute h-full w-full top-[-1px] left-[-1px] box-content;
    background-color: var(--vision-slido-tab-active-background-color, theme('colors.white'));
    border-color: var(--vision-slido-tab-active-border-color, theme('colors.grey.DEFAULT'));
}

.VisionSlidoTab__btn {
    @apply z-10 relative rounded-lg w-full h-full block overflow-hidden;
}

/**
    Modifiers
*/

.VisionSlidoTab--selected {
    .VisionSlidoTab__bg {
        @apply block;
    }
}

.VisionSlidoTab--disabled {
    .VisionSlidoTab__btn {
        @apply cursor-not-allowed;
    }
}


.VisionSlidoTab--theme-promo {
  .VisionSlidoTab__bg {
    @apply rounded-xl;
    z-index: 2;
    border: 1px solid transparent;
    background:
      linear-gradient(
      var(--promo-bg, theme('colors.white')),
      var(--promo-bg, theme('colors.white')))
      padding-box,
      linear-gradient(0deg,
      var(--promo-key, theme('colors.purple')),
      var(--promo-highlight, theme('colors.blue-light')))
      border-box;
    box-shadow: 0px 0px 10px var(--promo-key),
      inset 0px 0px 6px var(--promo-key);
  }
}
</style>